import gql from 'graphql-tag'

export const FETCH_PRODUCTS = gql`
	query($ids: [ID!]!) {
		nodes(ids: $ids) {
			... on Product {
				id
				handle
				title
				vendor
				onlineStoreUrl
				availableForSale
				variants(first: 50) {
					edges {
						node {
							availableForSale
							id
							title
							price {
                amount
              }
							compareAtPrice {
                amount
              }
						}
					}
				}
				images(first: 2) {
					edges {
						node {
							originalSrc
							width
							height
						}
					}
				}
			}
		}
	}
`

export const FETCH_VARIANTS = `query Variants($vids: [ID!]!) {
  nodes(ids: $vids) {
    ... on ProductVariant {
      product {
        title
        handle
        vendor
      }
      selectedOptions {
      	name, value
      }
      image {
      	src, width, height
      }
    }
  }
}`
